import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { UserAccessModel } from '../models/user-access.model';
import { GroupModel } from '../models/group.model';
import { RoleModel } from '../models/role';
import { PermModel } from '../models/perm.model';
import { NotificationModel } from '../models/notification.model';

@Injectable({
  providedIn: 'root'
})
export class UserService {

  constructor(private apiService: ApiService) { }

  updateProfile(data: UserAccessModel): Observable<UserAccessModel> {
    return this.apiService.patch<UserAccessModel>(environment.userAccess, data);
  }

  listAllUsers(groupId?: any): Observable<UserAccessModel[]> {
    const params = groupId ? {groupId} : {};
    return this.apiService.get<UserAccessModel[]>(environment.userAccess, params);
  }

  getUserById(id: string | null): Observable<UserAccessModel> {
    const url = `${environment.userAccess}/${id}`;
    return this.apiService.get<UserAccessModel>(url, {});
  }

  getGroups(): Observable<GroupModel[]> {
    return this.apiService.get<GroupModel[]>(environment.groups, {});
  }

  updateUser(user: UserAccessModel): Observable<UserAccessModel> {
    return this.apiService.put<UserAccessModel>(environment.userAccess, user);
  }

  createUser(user: UserAccessModel): Observable<{ id: string; password: string; }> {
    return this.apiService.post<{ id: string; password: string; }>(environment.userAccess, user);
  }

  getRolesByGroupId(customerId: any): Observable<RoleModel[]> {
    return this.apiService.get<RoleModel[]>(environment.roles, { GroupId: customerId });
  }

  createRole(data: { Name: string; Description: string; AzureGroupId: string; User: string; }): Observable<any> {
    return this.apiService.post<any>(environment.roles, data);
  }

  updateRole(data: { Name: string; Description: string; AzureGroupId: string; User: string; Id: string; Active: number }): Observable<any> {
    return this.apiService.put<any>(environment.roles, data);
  }

  getPermissions(CustomerId: any): Observable<PermModel[]> {
    return this.apiService.get<PermModel[]>(environment.permissions, { CustomerId });
  }

  getPermsByRole(RoleId: string): Observable<PermModel[]> {
    return this.apiService.get<PermModel[]>(environment.permRole, { RoleId });
  }

  assignPermsToRole( data: { CreatedBy: string | undefined; RoleId: string; PermissionIds: ( string | null )[] } ): Observable<any> {
    return this.apiService.post<any>(environment.permRole, data);
  }

  getNotifications(userId: string): Observable<NotificationModel[]> {
    return this.apiService.get<NotificationModel[]>(environment.notification, { userid: userId });
  }

  dismissNotification(notification: NotificationModel): Observable<any> {
    return this.apiService.put<any>(environment.notification, notification);
  }
}
